import { combineReducers, Reducer } from "redux"
import { Action } from "../action/Action"
import { DomainState } from "./DomainState"
import { eventDetails, events } from "./events/reducers/events"

export const domain: Reducer<DomainState, Action> = combineReducers({
  events,
  eventDetails
})
